import { render, staticRenderFns } from "./selectorDict.vue?vue&type=template&id=19a74357"
import script from "./selectorDict.vue?vue&type=script&lang=js"
export * from "./selectorDict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports